import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-325e9cc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-search" }
const _hoisted_2 = { class: "flex rel" }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed, onMounted } from 'vue'
import { cloneDeep } from 'lodash'
import { productTypeSnum } from './data'
import { clearForm, setDefaultForm, filterObjectKey } from '@/util/common'
import { isD2C, isJA, useSite2Station, isMultiStore } from '@/store'
import dblclick from '@/components/BatchSearch/index'
import NewInputBatchSearch from '@/components/NewInputBatchSearch/index.vue'
import { useStore } from 'vuex'
import { ShopType } from '@/common/const'
import { ShopPurchaseRespDTO } from '@/service/customer'

export default /*#__PURE__*/_defineComponent({
  props: ['form', 'isAmazon'],
  emits: ['update:form'],
  setup(__props, { emit: emits }) {

const props = __props
const moreWarehouseConfig = computed<ShopPurchaseRespDTO>(() => store.getters.moreWareConfig)
const showStockTip = ref(true)

const closeStockTip = () => {
  showStockTip.value = false
  localStorage.setItem('PSearchTip', 'true')
}

onMounted(() => {
  const PSearchTip = localStorage.getItem('PSearchTip')
  if (PSearchTip) {
    showStockTip.value = false
  }
})

const store = useStore()
const isCrossMall = computed(() => store.getters.isCrossMall)
const isTikTokShop = computed(() => store.getters.shopInfo?.customerShopPlatform === ShopType.TIKTOK)




const shopProductSkuType = ref(1)
const defaultForm = {
  productSkuOrName: '',
  shopProductSku: '',
  productType: '',
  startPendingStorage: '',
  endPendingStorage: '',
  startAmazonSellQuantity: '',
  endAmazonSellQuantity: '',
  startLockQuantity: '',
  endLockQuantity: '',
  startAvailableQuantity: '',
  endAvailableQuantity: '',
  startAgeQuantity: '',
  endAgeQuantity: '',
  customSupplierNameIsEmpty: ''
}
const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const _form = ref(getForm(props.form))

watch(() => props.form, (newValue) => {
  const { shopProductSku, customerProductMskuList, shopProductSkuList, productSkuList, productSkuOrName, ...reset } = newValue

  let _shopProductSkuList
  let _customerProductMskuList = customerProductMskuList
  //   如果是isAmazon且不是2c
  if ((props.isAmazon || isCrossMall.value) && !isD2C()) {
    if (shopProductSkuType.value === 1) {
      // 新增逻辑 单个元素的话走之前的字段customerProductMskuList，精准搜索
      _shopProductSkuList = customerProductMskuList?.length ? customerProductMskuList : shopProductSkuList
      _customerProductMskuList = undefined
    } else {
      // 新增逻辑 单个元素的话走之前的字段shopProductSku，精准搜索
      _shopProductSkuList = shopProductSku ? [shopProductSku] : shopProductSkuList
    }
  }
  //   如果不是isAmazon且不是2c
  if (!props.isAmazon && !isCrossMall.value && !isD2C()) {
    _shopProductSkuList = customerProductMskuList?.length ? customerProductMskuList : shopProductSkuList
    _customerProductMskuList = undefined
  }
  const _productSkuList = productSkuOrName ? [productSkuOrName] : productSkuList
  const value = {
    shopProductSkuList: _shopProductSkuList,
    productSkuList: _productSkuList,
    customerProductMskuList: _customerProductMskuList,
    ...reset

  }
  _form.value = getForm(value)
})
const submit = () => {
  const submitForm = cloneDeep(_form.value)
  const realVal = getRealVal()
  if (quantitySymbol.value && quantity.value!) {
    if (quantityType.value === 'pendingStorage') {
      console.log(realVal)
      submitForm.startPendingStorage = realVal[0]
      submitForm.endPendingStorage = realVal[1]
    }
    if (quantityType.value === 'amazonSellQuantity') {
      submitForm.startAmazonSellQuantity = realVal[0]
      submitForm.endAmazonSellQuantity = realVal[1]
    }
    if (quantityType.value === 'lockQuantity') {
      submitForm.startLockQuantity = realVal[0]
      submitForm.endLockQuantity = realVal[1]
    }
    if (quantityType.value === 'availableQuantity') {
      submitForm.startAvailableQuantity = realVal[0]
      submitForm.endAvailableQuantity = realVal[1]
    }
    if (quantityType.value === 'unableProcessDefectiveProducts') {
      submitForm.startUnableProcessDefectiveProducts = realVal[0]
      submitForm.endUnableProcessDefectiveProducts = realVal[1]
    }
    if (quantityType.value === 'inventory') {
      submitForm.startAgeQuantity = realVal[0]
      submitForm.endAgeQuantity = realVal[1]
    }
  } else {
    submitForm.startPendingStorage = undefined
    submitForm.endPendingStorage = undefined
    submitForm.startAmazonSellQuantity = undefined
    submitForm.endAmazonSellQuantity = undefined
    submitForm.startLockQuantity = undefined
    submitForm.endLockQuantity = undefined
    submitForm.startAvailableQuantity = undefined
    submitForm.endAvailableQuantity = undefined
    submitForm.startUnableProcessDefectiveProducts = undefined
    submitForm.endUnableProcessDefectiveProducts = undefined
    submitForm.startAgeQuantity = undefined
    submitForm.endAgeQuantity = undefined
  }
  //   判断长度，若是单个元素则走精准搜索，否则走模糊搜索
  const length = Number((submitForm.shopProductSkuList ?? [])?.length)
  //   如果是isAmazon且不是2c
  if ((props.isAmazon || isCrossMall.value) && !isD2C()) {
    if (shopProductSkuType.value === 1) {
      // 新增逻辑 单个元素的话走之前的字段customerProductMskuList，精准搜索
      submitForm.customerProductMskuList = length > 1 ? undefined : submitForm.shopProductSkuList
      if (length <= 1) {
        submitForm.shopProductSkuList = undefined
      }

      submitForm.shopProductSku = undefined
    } else {
      // 新增逻辑 单个元素的话走之前的字段shopProductSku，精准搜索
      submitForm.shopProductSku = length > 1 ? undefined : submitForm.shopProductSkuList?.[0]
      if (length <= 1) {
        submitForm.shopProductSkuList = undefined
      }

      submitForm.customerProductMskuList = undefined
    }
  }
  //   如果不是isAmazon且不是2c
  if ((!props.isAmazon && !isCrossMall.value) && !isD2C()) {
    // customerProductMskuList
    // 若是单个元素，直接走精准搜索
    submitForm.customerProductMskuList = length > 1 ? undefined : submitForm.shopProductSkuList
    if (length <= 1) {
      submitForm.shopProductSkuList = undefined
    }
  }
  const productSkuListLength = Number((submitForm.productSkuList ?? [])?.length)
  //   需要做处理，平台商品SKU若是单个搜索走精准搜索，否则走模糊搜索
  if (productSkuListLength <= 1) {
    submitForm.productSkuOrName = submitForm.productSkuList?.[0]
    submitForm.productSkuList = undefined
  }

  if (submitForm.customerProductMskuList && !(submitForm.customerProductMskuList instanceof Array)) {
    console.log(submitForm.customerProductMskuList)
    submitForm.customerProductMskuList = submitForm.customerProductMskuList?.split('\n')
  }
  emits('update:form', submitForm)
}

const resetForm = () => {
  clearForm(_form.value)
  quantitySymbol.value = ''
  quantity.value = ''
  quantityType.value = ''
  //   需要都重置下
  _form.value.customerProductMskuList = undefined
  _form.value.shopProductSkuList = undefined
  _form.value.productSkuList = undefined
  emits('update:form', cloneDeep({ ...toRaw(_form.value) }))
}

const quantityType = ref('availableQuantity')
const quantitySymbol: any = ref(1)
const quantity: any = ref(1)

const clearQuantity = () => {
  _form.value.startPendingStorage = ''
  _form.value.endPendingStorage = ''
  _form.value.startAmazonSellQuantity = ''
  _form.value.endAmazonSellQuantity = ''
  _form.value.startLockQuantity = ''
  _form.value.endLockQuantity = ''
  _form.value.startAvailableQuantity = ''
  _form.value.endAvailableQuantity = ''
  _form.value.startUnableProcessDefectiveProducts = ''
  _form.value.endUnableProcessDefectiveProducts = ''
  _form.value.startAgeQuantity = ''
  _form.value.endAgeQuantity = ''
}

const getRealVal = () => {
  let val: any = []
  if (quantitySymbol.value === 1) {
    val = [quantity.value, 999999999]
  } else if (quantitySymbol.value === 2) {
    val = [quantity.value, quantity.value]
  } else if (quantitySymbol.value === 3) {
    val = [0, quantity.value]
  }
  return val
}

const d2cProductSnum: any = {
  availableQuantity: t('可用库存'),
  lockQuantity: t('已锁定'),
  // sale: t('待入库'),
  pendingStorage: t('处理中'),
  inventory: t('库龄')
}

const b2bProductSnum = {
  availableQuantity: t('平台库存（可用库存）'),
  pendingStorage: t('平台库存（处理中）'),
  amazonSellQuantity: t('AMAZON库存(可售)'),
  lockQuantity: t('平台库存（已锁定）'),
  inventory: t('库龄')
}

const b2bNoAuthProductSnum = {
  availableQuantity: t('平台库存（可用库存）'),
  pendingStorage: t('平台库存（处理中）'),
  lockQuantity: t('平台库存（已锁定）'),
  inventory: t('库龄')
  // unableProcessDefectiveProducts: t('平台库存（待处理次品数）')
}

watch(() => quantityType.value, clearQuantity)


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      inline: true,
      model: _form.value
    }, {
      default: _withCtx(() => [
        (_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(t)('店舗商品名')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.thirdItemName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.thirdItemName) = $event)),
                  placeholder: _unref(t)('双击批量搜索'),
                  maxlength: "100",
                  style: {"margin-right":"4px","width":"100%"},
                  class: "searchitem"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: _unref(t)('客户商品sku')
            }, {
              default: _withCtx(() => [
                _createVNode(NewInputBatchSearch, {
                  modelValue: _form.value.customerProductMskuList,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.customerProductMskuList) = $event)),
                  placeholder: _unref(t)('双击批量搜索'),
                  maxlength: "100",
                  style: {"margin-right":"4px","width":"100%"},
                  class: "searchitem"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (!(__props.isAmazon || _unref(isCrossMall)) && !_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: _unref(t)('客户商品sku')
            }, {
              default: _withCtx(() => [
                _createVNode(NewInputBatchSearch, {
                  modelValue: _form.value.shopProductSkuList,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.shopProductSkuList) = $event)),
                  placeholder: _unref(t)('双击批量搜索'),
                  maxlength: "100",
                  style: {"margin-right":"4px","width":"100%"},
                  class: "searchitem"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        ((__props.isAmazon || _unref(isCrossMall)) && !_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "SKU"
            }, {
              default: _withCtx(() => [
                (shopProductSkuType.value === 1)
                  ? (_openBlock(), _createBlock(NewInputBatchSearch, {
                      key: 0,
                      modelValue: _form.value.shopProductSkuList,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.shopProductSkuList) = $event)),
                      placeholder: _unref(t)('双击批量搜索'),
                      style: {"margin-right":"4px","width":"100%"},
                      class: "searchitem"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: shopProductSkuType.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shopProductSkuType).value = $event)),
                          style: {"width":"160px"},
                          class: "prependSel",
                          onChange: _cache[4] || (_cache[4] = ($event: any) => {_form.value.shopProductSkuList = undefined; _form.value.customerProductMskuList = undefined})
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _unref(t)('客户商品sku'),
                              value: 1
                            }, null, 8, ["label"]),
                            (_unref(isCrossMall))
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 0,
                                  label: _unref(t)('CROSS MALL SKU'),
                                  value: 3
                                }, null, 8, ["label"]))
                              : (_openBlock(), _createBlock(_component_el_option, {
                                  key: 1,
                                  label: _unref(t)('Amazon SKU'),
                                  value: 2
                                }, null, 8, ["label"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]))
                  : (_openBlock(), _createBlock(NewInputBatchSearch, {
                      key: 1,
                      modelValue: _form.value.shopProductSkuList,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_form.value.shopProductSkuList) = $event)),
                      placeholder: _unref(t)('双击批量搜索'),
                      style: {"margin-right":"4px","width":"100%"},
                      class: "searchitem"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: shopProductSkuType.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((shopProductSkuType).value = $event)),
                          style: {"width":"160px"},
                          class: "prependSel",
                          onChange: _cache[7] || (_cache[7] = ($event: any) => {_form.value.shopProductSkuList = undefined; _form.value.customerProductMskuList = undefined})
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _unref(t)('客户商品sku'),
                              value: 1
                            }, null, 8, ["label"]),
                            (_unref(isCrossMall))
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 0,
                                  label: _unref(t)('CROSS MALL SKU'),
                                  value: 3
                                }, null, 8, ["label"]))
                              : (_openBlock(), _createBlock(_component_el_option, {
                                  key: 1,
                                  label: _unref(t)('Amazon SKU'),
                                  value: 2
                                }, null, 8, ["label"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('平台商品SKU')
        }, {
          default: _withCtx(() => [
            _createVNode(NewInputBatchSearch, {
              modelValue: _form.value.productSkuList,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_form.value.productSkuList) = $event)),
              placeholder: _unref(t)('双击批量搜索'),
              maxlength: "100",
              style: {"width":"100%"},
              class: "searchitem"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品类型'),
          class: "searchitem"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.productType,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_form.value.productType) = $event)),
              style: {"margin-right":"4px","width":"100%"},
              class: "searchitem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  key: "value",
                  label: _unref(t)('全部'),
                  value: ''
                }, null, 8, ["label"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterObjectKey)(_unref(productTypeSnum), _unref(isJA)() ? '' : '3'), (label, value) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: value,
                    label: label,
                    value: value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('保管费计费尺寸')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.volume,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_form.value.volume) = $event)),
              style: {"margin-right":"4px","width":"100%"},
              class: "searchitem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  key: "value",
                  label: _unref(t)('全部'),
                  value: ''
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  key: "XS",
                  label: "XS",
                  value: "XS"
                }),
                _createVNode(_component_el_option, {
                  key: "S",
                  label: "S",
                  value: "S"
                }),
                _createVNode(_component_el_option, {
                  key: "M",
                  label: "M",
                  value: "M"
                }),
                _createVNode(_component_el_option, {
                  key: "L",
                  label: "L",
                  value: "L"
                }),
                _createVNode(_component_el_option, {
                  key: "XL",
                  label: "XL",
                  value: "XL"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          class: "select-form",
          label: _unref(isD2C)() ? _unref(t)('可用库存数量筛选') : _unref(t)('筛选条件'),
          style: {"margin-right":"20px!important"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_select, {
                modelValue: quantityType.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((quantityType).value = $event)),
                style: _normalizeStyle({ marginRight: '4px', maxWidth: _unref(isD2C)() ? '110px' : '250px', width: _unref(isD2C)() ? '' : '220px' })
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(isD2C)() ? d2cProductSnum : __props.isAmazon ? b2bProductSnum : b2bNoAuthProductSnum, (label, value) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      label: label,
                      value: value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "style"]),
              _createVNode(_component_el_input, {
                modelValue: quantity.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((quantity).value = $event)),
                style: {"margin-right":"4px","flex":"1","width":"200px"}
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: quantitySymbol.value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((quantitySymbol).value = $event)),
                    style: {"width":"80px"},
                    class: "prependSel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: '≥',
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: '=',
                        value: 2
                      }),
                      _createVNode(_component_el_option, {
                        label: '≤',
                        value: 3
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品采购国家')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.purchaseCountry,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_form.value.purchaseCountry) = $event)),
              style: {"margin-right":"4px","width":"100%"},
              class: "searchitem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  key: "value",
                  label: _unref(t)('全部'),
                  value: ''
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('中国'),
                  value: "CN"
                }, null, 8, ["label"]),
                (_unref(isD2C)())
                  ? (_openBlock(), _createBlock(_component_el_option, {
                      key: 0,
                      label: _unref(t)('日本'),
                      value: "JP"
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('供应商是否为空')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.customSupplierNameIsEmpty,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_form.value.customSupplierNameIsEmpty) = $event)),
              style: {"margin-right":"4px","width":"100%"},
              class: "searchitem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('全部'),
                  value: ''
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('是'),
                  value: true
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('否'),
                  value: false
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(isCrossMall))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: _unref(t)('关联状态'),
              class: "fx-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _form.value.crossMallBindStatus,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_form.value.crossMallBindStatus) = $event)),
                  style: {"margin-right":"4px","width":"100%"},
                  placeholder: _unref(t)('请选择')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('全部'),
                      value: undefined
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('未关联'),
                      value: "1"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('已关联'),
                      value: "2"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: resetForm }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})